import { BreakpointQueryLarge } from '@hungryroot/ui-kit';
import { type MiniQuiz255 } from '../hooks/useMiniQuiz255';

/**
 * Exp 255 mini-quiz is a mobile-only funnel. Desktop treatment variants keep the
 * control /quiz/ experience — same breakpoint as freemium route gating.
 */
export function isExp255MiniQuizViewport(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return !window.matchMedia(BreakpointQueryLarge).matches;
}

export function shouldUseExp255MiniQuizFunnel(
  flags: MiniQuiz255,
  isMobile = isExp255MiniQuizViewport()
): boolean {
  if (flags.isLoading) {
    return false;
  }

  return isMobile && (flags.isVariant1 || flags.isVariant2);
}
